module.exports = __webpack_public_path__ + "img/1F507.05b0386c.svg";